import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import * as popups from "../../constants/popup-types";


class SetDefaultAddress extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'SetDefaultAddress';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.setDefaultAddress, payload);
    }

    // custom on failure
    onFailure(response, methodName = ''){
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        //if the update succeeded, fetch the updated data
        this.dispatch(Actions.getUserData());
    }

}


export default SetDefaultAddress;